export type LoginUi = {
  user: string;
  userError?: string;
  password: string;
  passwordVisible: boolean;
  passwordError?: string;
  isLoading?: boolean;
  signInButtonDisabled: boolean;
};

export const loginInitialState: LoginUi = {
  user: '',
  password: '',
  passwordVisible: false,
  signInButtonDisabled: false,
};
